import {
  Component,
  OnInit,
  Input,
  HostListener,
  ElementRef,
  OnDestroy
} from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Router, ResolveEnd } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { filter } from 'rxjs/operators';
import { Item } from '@sitecore-jss/sitecore-jss/types/layout';
import { IActiveItem } from '../../shared/interfaces/active-item.interface';
@Component({
  selector: 'ab-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit, OnDestroy {
  @Input() rendering: ComponentRendering;

  public toggleMobileMenu = false;
  public inMobileView: boolean;
  public subMenuOpen: { [key: string]: boolean } = {};

  private breakpointSubscription: Subscription;
  private routerSubscription: Subscription;

  @HostListener('document:click', ['$event'])
  documentClick(event) {
    if (!this.element.nativeElement.contains(event.target)) {
      this.subMenuOpen = {};
    }
  }

  constructor(
    private breakpointObserver: BreakpointObserver,
    private element: ElementRef,
    private router: Router
  ) {}

  ngOnInit() {
    this.selectActiveMenu(this.router.url);

    this.breakpointSubscription = this.breakpointObserver
      .observe('(max-width: 767.98px)')
      .subscribe((state: BreakpointState) => {
        this.inMobileView = state.matches;
      });

    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof ResolveEnd))
      .subscribe(event => {
        this.subMenuOpen = {};
      });
  }

  ngOnDestroy() {
    if (this.breakpointSubscription) {
      this.breakpointSubscription.unsubscribe();
    }

    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  showMobileMenu() {
    this.toggleMobileMenu = !this.toggleMobileMenu;
  }

  isOpen(id: string) {
    return !!this.subMenuOpen[id];
  }

  showSubMenu(link, id: string) {
    if (link) {
      this.router.navigate([link.url]);
      return;
    }

    if (!this.inMobileView && !this.subMenuOpen[id]) {
      this.subMenuOpen = {};
    }

    this.subMenuOpen[id] = !this.subMenuOpen[id];
  }

  isAccessEnabled(items: Item[]) {
    if (!items || items.length === 0) {
      return true;
    }

    return items.some((subItem: any) => {
      return subItem.fields.Link?.fields.AccessEnabled === 'True';
    });
  }

  private selectActiveMenu(url: string) {
    if (url.indexOf('?') !== -1) {
      url = url.split('?')[0];
    }

    const items = this.rendering.fields
      ? (this.rendering.fields.items as IActiveItem[])
      : [];

    if (items && items.length !== 0) {
      items.some(item => {
        this.setActiveMenuRecursive(item, item, url);

        return item.isActive;
      });
    }
  }

  private setActiveMenuRecursive(
    mainItem: IActiveItem,
    item: Item,
    url: string
  ) {
    if (item.fields.Link) {
      mainItem.isActive = (item.fields.Link as any).url.indexOf(url) !== -1;
    } else {
      if (
        item.fields.items &&
        (item.fields.items as IActiveItem[]).length !== 0
      ) {
        (item.fields.items as IActiveItem[]).some(subItem => {
          this.setActiveMenuRecursive(mainItem, subItem, url);

          return mainItem.isActive;
        });
      } else {
        mainItem.isActive = false;
      }
    }
  }
}
